import { render, staticRenderFns } from "./Now.vue?vue&type=template&id=5dffbeb4"
import script from "./Now.vue?vue&type=script&lang=js"
export * from "./Now.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dffbeb4')) {
      api.createRecord('5dffbeb4', component.options)
    } else {
      api.reload('5dffbeb4', component.options)
    }
    module.hot.accept("./Now.vue?vue&type=template&id=5dffbeb4", function () {
      api.rerender('5dffbeb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/Now.vue"
export default component.exports